<app-list-header [headerName]="headerName"></app-list-header>
<app-lessons-list *ngIf="classId"
  [lessonStatus]="lesson_completed"
  [studentClassId]="classId"
  [showHeader]="false"
  [onlyStatuses]="[lesson_completed]">
</app-lessons-list>
